module.exports = __webpack_public_path__ + "static/media/2.488b9449.png";